import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const MoneyTransferIllustration = ({ width = 39, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 42">
      <defs>
        <path id="f1w02fw0ga" d="M0 42L39 42 39 0 0 0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#00396C"
          d="M26.656 37.129H14.742l1.679-1.707c.335-.34.325-.882-.022-1.211-.347-.329-.9-.319-1.234.022l-3.695 3.752 3.695 3.753c.17.175.399.262.628.262.218 0 .437-.079.606-.24.347-.329.357-.871.022-1.212l-1.68-1.706h11.915c.482 0 .874-.383.874-.857 0-.473-.392-.856-.874-.856M23.835.262c-.335-.34-.887-.35-1.233-.021-.348.328-.358.87-.023 1.21l1.68 1.707H12.344c-.482 0-.873.384-.873.857s.39.856.873.856H24.26l-1.68 1.707c-.335.34-.325.883.023 1.21.168.162.386.242.605.242.23 0 .457-.088.628-.262l3.694-3.753L23.835.262z"
        />
        <path fill="#006474" d="M0 31.335L39 31.335 39 10.688 0 10.688z" />
        <path fill="#6AB3A9" d="M2.293 29.041L36.705 29.041 36.705 12.982 2.293 12.982z" />
        <path
          fill="#FFBF00"
          d="M19.5 26.266c2.852 0 5.162-2.31 5.162-5.16 0-2.852-2.31-5.163-5.162-5.163s-5.162 2.311-5.162 5.162 2.31 5.161 5.162 5.161"
        />
        <path fill="#000" d="M19.5 31.335L39 31.335 39 10.688 19.5 10.688z" opacity=".1" />
      </g>
    </svg>
  </DefaultIconWrapper>
);
